import React from 'react';
import { useId } from '@reach/auto-id';
import { Tooltip } from '../../../../CommonComponents/OPL/Tooltip/Tooltip';
import { GoalType } from '../../api/useGoalsQuery';
import { Icon } from '../../../../CommonComponents/OPL/Icon/Icon';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { GoalTileButton } from './GoalTile.styles';
import { GOAL_ICON_MAP } from '../../Goals.meta';

interface Props {
  name: string;
  type: GoalType;
  onClick(): void;
  checked?: boolean;
  icon?: string;
  disabledMessage?: string;
  customIcon?: React.ReactNode;
}

export const GoalTile = ({
  name,
  checked,
  disabledMessage,
  icon,
  type,
  onClick,
  customIcon,
}: Props) => {
  const buttonTextId = useId();

  return (
    <Tooltip disabled={!disabledMessage} content={disabledMessage} placement="bottom">
      <span>
        <GoalTileButton
          onClick={onClick}
          disabled={!!disabledMessage}
          aria-pressed={checked}
          aria-labelledby={buttonTextId}
        >
          {customIcon || (
            <Icon
              className={icon || GOAL_ICON_MAP[type]}
              fontSize="h3"
              color={checked ? 'primary.600' : 'neutral.500'}
            />
          )}

          <Text
            id={buttonTextId}
            as="span"
            fontSize="h6"
            fontWeight={500}
            color={checked ? 'primary.600' : 'neutral.600'}
            textAlign="center"
          >
            {name}
          </Text>

          {checked && (
            <Icon
              className="fas fa-check-circle"
              fontSize="h6"
              color="primary.600"
              css="position: absolute; bottom: 24px"
              aria-hidden
            />
          )}
        </GoalTileButton>
      </span>
    </Tooltip>
  );
};
